import router from '@/router';
import store from '@/store'
import apiClient from '@/api/index'
import { PROJECT_PREFIX } from "@/constants/projects";
import { cacheProfile } from "@/utils/profileCache";

export const loginModule = {
    namespaced: true,

    state:() => ({
        token: null,
        error: false,
        errorMessage: '',
    }),

    mutations: {
        setToken(state, token) {
            state.token = token
        },

        setError(state, bool) {
            state.error = bool
        },

        setErrorMessage(state, message) {
            state.errorMessage = message
        }
    },

    actions: {
        async loginWithPassword({ commit, dispatch }, { phone, password, modal }) {
            const cleanPhone = phone.replace(/\s+/g, '').replace('+', '')

            await apiClient.post(PROJECT_PREFIX.tcode + "/auth/password/", {
                phone: cleanPhone,
                password: password,
            })
            .then((response) => {
                commit('setToken', response.data.token)
                commit('setError', false)
                dispatch('userAuth', modal || null)
            })
            .catch((error) => {
                commit('setError', true)
                if (error.response && error.response.data && error.response.data.error) {
                    commit('setErrorMessage', error.response.data.error)
                } else {
                    commit('setErrorMessage', 'Ошибка авторизации')
                }
            });
        },

        async userAuth({ state }, modal) {
            try {
                const response = await apiClient.get(PROJECT_PREFIX.tcode + "/profile/", {
                    headers: {
                        Authorization: 'Token ' + state.token
                    }
                })

                localStorage.setItem('token', state.token);
                cacheProfile(response.data);
                store.dispatch('getProfileData')
                if(!modal) {
                    router.replace({ path: '/' })
                }
            } catch(err) {
                console.log(err);
            }
        },
    }
}
